import { GET_ITINERARY } from '../../../helpers/graphql/itineraries';
import { useQuery } from '@apollo/client';
import Itinerary from 'components/Destinations/Itinerary';
import ItineraryMap from 'components/Destinations/ItineraryMap';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function ItineraryEmbed({ author, permlink }) {
  const { data } = useQuery(GET_ITINERARY, {
    variables: { author, permlink },
  });

  const isScreenLg = useMediaQuery('(min-width: 576px)');
  const isScreenXl = useMediaQuery('(min-width: 1200px)');

  return (
    <>
      {data && data.itinerary && data.itinerary.places && (
        <div className="dark:tw-bg-primary-900 tw-bg-primary-100 tw-rounded-2xl mb-3">
          <div className="tw-h-96 tw-relative">
            <ItineraryMap
              width={isScreenXl ? 840 : isScreenLg ? 650 : 455}
              itinerary={data.itinerary}
              locationDetails={{ countryCode: data.itinerary.countryCode }}
              rounding="2"
            />
          </div>
          <div className="p-3">
            <Itinerary itinerary={data.itinerary} />
          </div>
        </div>
      )}
    </>
  );
}
